import { render, staticRenderFns } from "./shoplist.vue?vue&type=template&id=4a9dce88&scoped=true"
import script from "./shoplist.vue?vue&type=script&lang=ts"
export * from "./shoplist.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9dce88",
  null
  
)

export default component.exports